import React, { useState, useEffect } from 'react'
import RegisterLandingElement from '../../../components/Register/Register.jsx'
import {
  generateUID,
  addTMXScriptToBody,
} from '../../utility/threatMetrix/TMX.js'

export const AdvisorRegister = () => {
  const [tmxId, setTmxId] = useState()
  const websessionId = `web_session_${generateUID()}`

  useEffect(() => {
    addTMXScriptToBodyHandler()
  }, [])

  const addTMXScriptToBodyHandler = async () => {
    const tmx_id = `cti_adv_${generateUID()}`
    setTmxId(tmx_id)
    await addTMXScriptToBody(tmx_id)
  }

  return <RegisterLandingElement tmx_id={tmxId} websession_id={websessionId} />
}
